import React from 'react';
import PropTypes from 'prop-types';
import NodeActivityEditor from '../../NodeActivityEditor';
import SecondaryButton from '../../SecondaryButton';
import { PreviewSection, QuestionWrapper } from '../styles';
import { EditorHeaderRowLeft, HeaderUserName, EditorHeaderRowRight } from '../../NodeActivityEditor/styles';

const EvaluationContentPreview = ({ type, data, previewText }) => {
  const headerPanel = (
    <>
      <EditorHeaderRowLeft>
        <HeaderUserName>{i18n.__('app_student_editor')}</HeaderUserName>
      </EditorHeaderRowLeft>
      <EditorHeaderRowRight />
    </>
  );

  const buttonPanel = <SecondaryButton disabled={true} text={i18n.__('app_handin')} className={'ir-hide'} />;

  return (
    <PreviewSection>
      <hr />
      <QuestionWrapper dangerouslySetInnerHTML={{ __html: data.placeholder }} />
      <NodeActivityEditor type={type} headerPanel={headerPanel} buttonPanel={buttonPanel} editorText={previewText} />
    </PreviewSection>
  );
};

export default EvaluationContentPreview;

EvaluationContentPreview.propTypes = {
  type: PropTypes.string.isRequired,
  previewText: PropTypes.string.isRequired,
};
